export class KeyValueModel {
    constructor(
        public Key: any = "",
        public Value: string = ""
    ) { }
}
